import loadable from '@loadable/component';

export const namespace =
  'canalplus.block.selfcare.subscription_options_summary';
export const Component = loadable(
  () => import('./containers/SubscriptionOptionsSummaryContainer')
);
export { default as propsFormatter, getFormattedApis } from './propsFormatter';
